// Maps a pickup time string ("HH:MM" or "HH:MM AM/PM") to a color bucket.
// Buckets:
//   Late night (10pm–4am)   → purple
//   Early morning (4am–8am) → blue
//   Daytime (8am–5pm)       → green
//   Evening (5pm–10pm)      → orange

const parseHour24 = (raw) => {
  if (!raw || typeof raw !== "string") return null;
  const s = raw.trim();
  // 12-hour with meridiem, e.g. "11:30 PM"
  const m = s.match(/^(\d{1,2}):(\d{2})\s*(AM|PM|am|pm)?$/);
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const ap = (m[3] || "").toUpperCase();
  if (ap === "PM" && h < 12) h += 12;
  if (ap === "AM" && h === 12) h = 0;
  return isNaN(h) ? null : h;
};

const BUCKETS = [
  {
    key: "late_night",
    label: "Late Night",
    emoji: "🌙",
    // 22:00 – 04:00 (wraps midnight)
    match: (h) => h >= 22 || h < 4,
    // Tailwind classes
    badge: "bg-purple-100 text-purple-900 border-purple-300",
    dot: "bg-purple-500",
    ring: "ring-purple-400",
    solid: "bg-purple-600 text-white",
    row: "border-l-4 border-purple-500",
  },
  {
    key: "early_morning",
    label: "Early Morning",
    emoji: "🌅",
    match: (h) => h >= 4 && h < 8,
    badge: "bg-sky-100 text-sky-900 border-sky-300",
    dot: "bg-sky-500",
    ring: "ring-sky-400",
    solid: "bg-sky-600 text-white",
    row: "border-l-4 border-sky-500",
  },
  {
    key: "daytime",
    label: "Daytime",
    emoji: "☀️",
    match: (h) => h >= 8 && h < 17,
    badge: "bg-emerald-100 text-emerald-900 border-emerald-300",
    dot: "bg-emerald-500",
    ring: "ring-emerald-400",
    solid: "bg-emerald-600 text-white",
    row: "border-l-4 border-emerald-500",
  },
  {
    key: "evening",
    label: "Evening",
    emoji: "🌆",
    match: (h) => h >= 17 && h < 22,
    badge: "bg-orange-100 text-orange-900 border-orange-300",
    dot: "bg-orange-500",
    ring: "ring-orange-400",
    solid: "bg-orange-600 text-white",
    row: "border-l-4 border-orange-500",
  },
];

const FALLBACK = {
  key: "unknown",
  label: "Unknown",
  emoji: "•",
  badge: "bg-gray-100 text-gray-700 border-gray-300",
  dot: "bg-gray-400",
  ring: "ring-gray-300",
  solid: "bg-gray-500 text-white",
  row: "border-l-4 border-gray-300",
};

export const getPickupTimeStyle = (timeStr) => {
  const h = parseHour24(timeStr);
  if (h === null) return FALLBACK;
  return BUCKETS.find((b) => b.match(h)) || FALLBACK;
};

// Small badge component data — consumers build their own JSX from these tokens.
export const ALL_PICKUP_BUCKETS = BUCKETS;
